import 'stylesheets/components/licensePlates.scss';
import 'stylesheets/components/page.scss';
import 'stylesheets/global.scss';

import React, {PropTypes} from 'react';
import { reduxForm, getValues } from 'redux-form';
import { connect } from 'react-redux';
import _ from 'lodash';

import PureRenderComponent from 'app/lib/PureRenderComponent';
import history from 'app/lib/history';
import { store } from 'app/store';
import * as actionCreators from 'modules/profile/actions';
import { Select, Input, Row, Col, Toast } from 'routes/app/components';

const formName = 'licenseplates';

export const fields = ['licensePlate'];

export class LicensePlates extends PureRenderComponent {

    static propTypes = {
        fields: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        setPreferredLicensePlate: PropTypes.func.isRequired,
        licensePlate: PropTypes.string,
        licensePlates: PropTypes.array
    };

    get formData() {
        return getValues(store.getState().get('form').get(formName).toJS());
    }

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    getLicensePlates() {
        return ['None'].concat(this.props.licensePlates);
    }

    handleSubmit() {
        this.props.setPreferredLicensePlate(this.formData.licensePlate);
    }

    render() {

        const {fields: {licensePlate}, handleSubmit, submitting} = this.props;

        return (
            <Row>

                <Select s={12}
                        name="licensePlate" label="License plate"
                        options={this.getLicensePlates()}
                        {...licensePlate}
                />

                <Col s={12}>
                    <Toast waves="light"
                           toast="Preferred license plate saved"
                           disabled={submitting}
                           onClick={handleSubmit(this.handleSubmit)}>Save</Toast>
                </Col>

            </Row>
        );
    }

}

export const LicensePlatesContainer = reduxForm({
        form: formName,
        fields,
        getFormState: (state, reduxMountPoint) => state.get(reduxMountPoint).toJS()
    },
    state => {
        return {
            licensePlates: state.get('licensePlates').toJS(),
            initialValues: {
                licensePlate: state.get('profile').get('licensePlate')
            }
        };
    },
    {...actionCreators}
)(LicensePlates);
